module.exports = __webpack_public_path__ + "static/media/9.f5506107.png";